<template>
    <div class="dialog_right">
         <div class='pres_line'>
            <presLine :presData = 'dialog_data'></presLine>
        </div>
        <div class='video'>
            <!-- <span class='video_title'>视频图像</span> -->
            <!-- <div class='video_icon'>
                <img src="https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/4.png">
                <img src="https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/5.png">
            </div> -->
          

            
            <div class='video_box'>

                <el-image v-if='srcList.length>0' style="width: 100%; height: 100%  ":src="url":preview-src-list="srcList"></el-image>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import presLine from '../chart/pres_line.vue'
  export default {
    name: 'dialog_right',
    props:{
        dialogData:{
            type:Object,
            default:()=>{}
        },
        picTures:{
             type: Array,
             default:()=>[]
        }
       
    },
    data () {
      return {
          dialog_data:{},
          url:'',
          srcList: []
      }
    },
    components:{
        presLine
    },
    watch:{
        dialogData:{
            handler:function(newVal,oldVal){
                this.pageInit()
            },
            deep:true
        },
        picTures:{
            handler:function(newVal,oldVal){
                this.pictrues_set()
             },
            deep:true 
        }
    },
    mounted () {
        // var player = new EZUIPlayer('myPlayer');
        // player.on('error', function(){
        //     console.log('error');
        // });
        // player.on('play', function(){
        //     console.log('play');
        // });
        // player.on('pause', function(){
        //     console.log('pause');
        // });
    },
    computed: {

    },
    methods: {
        pageInit(){
            this.dialog_data ={};
            this.dialog_data = this.$deepClone(this.dialogData);

        },
        pictrues_set(){
            this.srcList = this.$deepClone(this.picTures);
             this.url = this.srcList[0];
              console.log('图像视频数据-=-=-=-=-=-=-',this.url)
        }
    }
  }
</script>
<style scoped lang='less'>
     .dialog_right{
          width: 100%;
        height: 100%;
        .pres_line{
            position: relative;   
            height: 50%;
            width: 100%;        
            }
        .video{
            position: absolute;   
            // background-color: skyblue;
            width: 80%;
            height: 35%;
            bottom: 2%;
            // padding: 0 0 0 0;
            left: 10%;           
            .video_box{
                position: relative;   
                height: 100%;
                width: 100%;
                bottom: 0px;
                background: url(../../../static/img/123.png) no-repeat;
                background-position: 100% 100%;
                background-size:100%;
               
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog_right.vue